import React from "react";
import autoBind from "react-autobind";

import { Row, Col } from "react-bootstrap";

import GridFilterBase from "./grid.filter.base";

import CONST_N from "@common/constraints/numbers.contraints";

import DDadosItem from "@common/components/ddados/ddados.item";

const I = {
  DE: 0,
  ATE: 1
};

class GridFilter extends GridFilterBase {
  constructor(props) {
    super(props, {
      de: { title: "De:", type: "number", operation: "de", showInAdvancedSearch: true, advancedSearchValues: [] },
      ate: { title: "Até:", type: "number", operation: "ate", showInAdvancedSearch: false }
    });
    autoBind(this);
  }

  getDefaultInputValues(column) {
    return {
      isDecimal: !!column.isDecimal,
      isNullable: !!column.isNullable,
      isLong: !!column.isLong,
      isNot: false,
      value: undefined,
      isShort: !!column.isShort,
      isByte: !!column.isByte
    };
  }

  hasValue = (value) => {
    const { column } = this.props;
    const { filtroValorZero } = column;

    return filtroValorZero ? (value != null && value != undefined) : value;
  }

  async isValid() {
    await this.handleOnBlur();
    const { column } = this.props;
    const { inputs } = column;
    const deValue = inputs[I.DE].value;
    const ateValue = inputs[I.ATE].value;

    if (
      column.isAdvancedSearch ||
      !column.showFaixa ||
      (!this.hasValue(deValue) && !this.hasValue(ateValue)) ||
      (this.hasValue(deValue) && this.hasValue(deValue) && parseFloat(deValue) <= parseFloat(ateValue))
    )
      return true;
    _alert.warning("Campo 'De' deve ser menor que 'Até'. ");
    inputs[I.DE].value = "";
    inputs[I.ATE].value = "";
    this.updateContextColumn(column, false);
    return false;
  }

  clearInputs(column) {
    const { inputs } = column;
    inputs.forEach(x => {
      x.value = "";
      x.advancedSearchValues = [];
      x.isNot = false;
    });
  }

  handleChangeValue(index, field) {
    let { column } = this.props;
    return value => {
      if (column.inputs && column.inputs[index]) {
        column.inputs[index][field] = value;
        if (!column.showFaixa && !column.isAdvancedSearch) {
          column.inputs[I.ATE][field] = column.inputs[I.DE][field];
        }
        this.updateContextColumn(column, false);
      }
    };
  }

  getMaxNumber() {
    let { column } = this.props;
    if (column.isLong) return CONST_N.MAX_LONG;
    if (column.isShort) return CONST_N.MAX_SHORT;
    if (column.isByte) return CONST_N.MAX_BYTE;

    return CONST_N.MAX_INTEGER;
  }

  isValidDeInput() {
    let { column } = this.props;
    let inputDe = column.inputs[I.DE];
    return parseInt(inputDe.value) <= this.getMaxNumber();
  }

  changeInputDeAte(column) {
    let inputDe = column.inputs[I.DE];
    let inputAte = column.inputs[I.ATE];

    if (inputDe.value && this.isValidDeInput()) {
      if (!inputAte.value || parseInt(inputAte.value) < parseInt(inputDe.value) || !column.showFaixa) inputAte.value = inputDe.value;
    }

    if (!inputDe.value && inputDe.value != 0 && column.showFaixa) {
      inputAte.value = undefined;
    }
  }

  async handleOnBlur() {
    let { column } = this.props;
    if (!column.isAdvancedSearch) {
      this.changeInputDeAte(column);
      await this.updateContextColumn(column, false);
    }
  }

  handleIsNot(e) {
    let { column } = this.props;
    let isNot = e.target.checked;
    column.inputs.forEach(x => (x.isNot = isNot));
    this.updateContextColumn(column);
  }

  onSubmit() {
    let { column } = this.props;
    if (column.isAdvancedSearch) {
      let inputDe = column.inputs[I.DE];
      if (inputDe || inputDe == "0") {
        this.addAdvancedSearch(0, true)();
      }
    }
  }

  addAdvancedSearch(index, ignoreEmpty) {
    let { column } = this.props;
    return e => {
      let input = column.inputs[index];
      if (!input.value) {
        if (!ignoreEmpty) _alert.warning("Digite um termo a ser pesquisado.");
        return;
      }
      let splitValues = input.value.split(";");
      input.advancedSearchValues = [...input.advancedSearchValues, ...splitValues];
      input.value = "";
      this.updateContextColumn(column);
    };
  }

  removeAdvancedSearch(indexInput, index) {
    let { column } = this.props;
    return e => {
      let inputItem = column.inputs[indexInput];
      inputItem.advancedSearchValues.splice(index, 1);
      this.updateContextColumn(column);
    };
  }

  changeAdvancedSearch() {
    let { column } = this.props;
    column.isAdvancedSearch = !column.isAdvancedSearch;
    this.clearInputs(column);
    this.updateContextColumn(column);
  }

  changeShowFaixa() {
    let { column } = this.props;
    column.showFaixa = !column.showFaixa;
    this.changeInputDeAte(column);
    this.updateContextColumn(column, false);
  }

  render() {
    const { column } = this.props;
    const { isAdvancedSearch, inputs } = column;
    if (!inputs) return null;
    return (
      <ul>
        {inputs.map(this.renderInput)}
        {!isAdvancedSearch && (
          <a onClick={this.changeShowFaixa}>
            <span>{column.showFaixa ? "Busca por Coincidentes" : "Busca por Faixa"}</span>
          </a>
        )}
        <p className="advanced-search" onClick={this.changeAdvancedSearch}>
          <span>{isAdvancedSearch ? "Retornar para a busca simples" : "Busca avançada"}</span>
        </p>
      </ul>
    );
  }

  renderInput(input, index) {
    const { column } = this.props;
    const { isAdvancedSearch, showFaixa } = column;
    if (index == I.ATE && (!showFaixa || isAdvancedSearch)) return;
    const name = `${column.dataName}${input.operation}`;
    return (
      <li className="filterLine" key={index}>
        <div className="filterColunm">
          <Row>
            <Col lg={isAdvancedSearch ? 10 : 12}>
              <DDadosItem
                name={name}
                onChange={this.handleChangeValue(index, "value")}
                forceSync={true}
                onBlur={this.handleOnBlur}
                Placeholder={false}
                Tooltip={false}
                TipoNumero={column.isShort ? "short" : column.isLong ? "long" : column.isByte ? "byte" : ""}
                Label={isAdvancedSearch ? "Pesquisar Por:" : index == I.DE && !column.showFaixa ? "Igual:" : input.title}
                Tipo="number"
                state={{ [name]: input.value }}
                onDisableFormUpdated={true}
                allowseparator={isAdvancedSearch}
              />
            </Col>
            {isAdvancedSearch && (
              <Col lg={1}>
                <label>&nbsp;</label>
                <button type="button" className="btn btn-primary btn-custom" onClick={this.addAdvancedSearch(index)}>
                  <i className="fa fa-plus" />
                </button>
              </Col>
            )}
          </Row>
          {isAdvancedSearch && (
            <Row>
              <Col lg={12}>
                <label className="advanced-search-label">Termos pesquisados</label>
                <ul className="advanced-search-list">
                  {input.advancedSearchValues == 0 && <li className="empty-message">Não há termos a serem pesquisados.</li>}

                  {input.advancedSearchValues.map((item, i) => (
                    <li key={i}>
                      <i className="fa fa-times-circle" title={"Remover da Busca Avançada"} onClick={this.removeAdvancedSearch(index, i)} />{" "}
                      <span title={item}>{item}</span>
                    </li>
                  ))}
                </ul>
              </Col>
            </Row>
          )}
          {isAdvancedSearch && (
            <div className="filterColunm mt-2">
              <label className="checkbox">
                <input className="mt-0" type="checkbox" value={input.isNot || false} onChange={this.handleIsNot} /> Registros não coincidentes
              </label>
            </div>
          )}
        </div>
      </li>
    );
  }
}

export default GridFilter;
